import { render, staticRenderFns } from "./task-dashboard.vue?vue&type=template&id=68eca07f&"
import script from "./task-dashboard.vue?vue&type=script&lang=js&"
export * from "./task-dashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports